import gruasAlfa from './profiles/gruasAlfa'
import gruasMonterrey from './profiles/gruasMonterrey'
import gruasSaltillo from './profiles/gruasSaltillo'

const BRAND_BY_ID = {
  'gruas-monterrey': gruasMonterrey,
  'gruas-saltillo': gruasSaltillo,
  'gruas-alfa': gruasAlfa,
}

const selectedBrandId = process.env.VUE_APP_BRAND || 'gruas-monterrey'

const brand = BRAND_BY_ID[selectedBrandId] || gruasMonterrey

export default brand
